export const SEX_LIST = ['男性', '女性', 'その他']
export const AGE_LIST = ['10代', '20代', '30代', '40代', '50代', '60代', '70代以上']
export const PURPOSE_LIST = ['観光', 'ビジネス', '帰省・知人訪問']
export const FELLOW_LIST = ['自分ひとり', '家族（小学生以下の子供有）', '家族（小学生以下の子供無）', '友人', 'その他']
export const CONSIDER_LIST = ['全く気にしない', '気にしない', 'ときどき心がける', '心がけている', '必ず心がけている']
export const LATE_LIST = ['全く気にしない', '気にしない', 'ときどき心がける', '心がけている', '必ず心がけている']
export const YES_NO_LIST = ['はい', 'いいえ']
export const SPOT_EX_LIST = [
  {
    'img': 'restaurant-0.png',
    'text': '飲食店'
  },
  {
    'img': 'shop-0.png',
    'text': '買い物'
  },
  {
    'img': 'sight-0.png',
    'text': '観光'
  },
  {
    'img': 'leisure-0.png',
    'text': '温泉'
  }
]



// WEBPACK FOOTER //
// ./src/const.js